import React, { Component } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Button, IconButton } from "@mui/material";
import { FormControl } from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import MoreOptions from "../moreOptions";
import settings from "../../helpers/Settings";
import Row from "react-bootstrap/Row";
import Cookies from "js-cookie";
import Col from "react-bootstrap/Col";
import axios from "axios";
import * as XLSX from "xlsx";
import Checkbox from "@mui/material/Checkbox";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Accordion from "react-bootstrap/Accordion";
import * as moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Typography from "@mui/material/Typography";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CircularProgress from "@mui/material/CircularProgress";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import EditIcon from '@mui/icons-material/Edit';
import { CSVLink } from "react-csv";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import EditClaimInfo from "./updateClaimInfo";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

let { KayanURL } = settings;
const styleModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  bgcolor: "background.paper",
  borderRadius: "20px",
  p: 4,
};
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid gray",
  borderRadius: "20px",
  boxShadow: 24,
  p: 4,
};
class claimsUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchClaimResponse: false,
      approvalInfoExist: false,
      defaultpayerIdValue: "",
      claims: [],
      claimsForCancel: [],
      batchSubmissionFlag: false,
      checkboxFlag: false,
      claimInfoModal: false
    };
  }
  componentDidMount = async () => {
    let nphiesID = localStorage.getItem("nphies-id")
    this.setState({ nphiesID })
  }

  onFileChange = (e) => {
    this.setState({ selectedFile: e.target.files[0], errMsg: "" });
  };
  handleFileUpload = (e) => {
    if (!this.state.selectedFile) {
      this.setState({
        errMsg: "please select a file !",
      });
    } else {
      const reader = new FileReader();
      reader.readAsBinaryString(this.state.selectedFile);
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const parsedData = XLSX.utils.sheet_to_json(sheet);

        this.sendReq(parsedData, e);
      };
    }
  };
  sendReq = async (parsedData, e) => {
    console.log("upload data");
    let Response = await axios.post(
      /* KayanURL  */ "http://localhost:4000/" +
      "api/KSA/RCM/Claims/uploadClaim",
      {
        data: parsedData,
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );

    console.log("Response", Response);
    if (Response) {
      let { data } = Response;
      if (data) {
        if (data.success) {
          this.setState({ success: true, uploadModal: false });
          //this.getAllClaims();
        } else {
          this.setState({ success: false, error: data.error });
        }
      }
    }
  };

  closeUploadModal = () => {
    this.setState({
      uploadModal: false
    });
  };
  closeClaimInfoModal = () => {
    this.setState({
      claimInfoModal: false
    });
  }
  handleCloseErrorMessage = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    this.setState({ batchSubmissionError: null });
  };
  /*  getAllClaims = async () => {
    let result = await axios.put(
      KayanURL + "api/KSA/RCM/uploadClaims/getAllClaimSubmission",
      {
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );
    if (result) {
      let { data } = result;
      if (data) {
        console.log("heree", data);
        if (data.success) {
          this.setState({
            success: true,
            allvisits: data.claims,
            //requestsFound: false,

            searchClaimResponse: false,
          });
        } else {
          this.setState({
            success: false,
            error: data.error,
            allvisits: [],
          });
        }
      }
    }
  }; */
  handleDeleteClaimSubmission = async (index) => {
    let result = await axios.put(
      KayanURL + "api/KSA/RCM/uploadClaims/deleteClaimSubmissionById",
      {
        id: index,
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );
    if (result) {
      let { data } = result;
      if (data) {
        if (data.success) {
          this.setState({
            success: true,
            allvisits: data.allVisits,
          });
        } else {
          this.setState({
            success: false,
            error: data.error,
            allvisits: data.allVisits,
          });
        }
      }
    }
  };

  getAllClaimInformation = async (visit) => {
    console.log("visit", visit);
    this.setState({
      selectedVisit: visit,
      viewClaimSubmissionInfoModal: true,
      claimSubmissionItemsRows: [],
      errorsRow: [],
      queuedInfoRows: {},
    });

    const year = new Date().getFullYear();
    const dateSplit = visit.patient_dob.split("-");
    const birthYear = dateSplit[0];
    const age = year - birthYear;

    visit["age"] = age;
    /*     this.setState({ selectedVisit: visit });
     */
    /*   if (visit.authorizationstatus !== null) {
      //get the claim authorization info
      this.setState({
        approvalInfoExist: true,
      });

      let getApprovalInfo = await axios.put(
        KayanURL + "api/KSA/RCM/patient/getAllAuthInfoByVisitID",
        {
          apiToken: Cookies.get("RCM_KSA_Employee_Token"),
          visitId: visit.id,
        }
      );

      if (getApprovalInfo) {
        let { data } = getApprovalInfo;
        if (data.success) {
          let { AllApproval } = data;

          if (AllApproval && AllApproval.length > 0) {
            console.log("approval info", AllApproval[0]);
            let { adjucationoutcome, items, totals } = AllApproval[0];

            visit["approvalAdudicationOutcome"] = adjucationoutcome;

            let { allprocedures } = visit;

            if (allprocedures && allprocedures.length > 0) {
              allprocedures.forEach((procedure, index) => {
                console.log(items[index]);
                let { outcome, reason, denailCode, adjudications } =
                  items[index];
                procedure["outcome"] = outcome;
                procedure["reason"] = reason;
                procedure["denailCode"] = denailCode;
                procedure["adjudications"] = adjudications;
              });
            }
            visit["allprocedures"] = allprocedures;
            this.setState({ selectedVisit: visit });
          }
        }
      }
    } else {
      this.setState({
        approvalInfoExist: false,
      });
    } */

    /*  if (visit.procedures) {
      let { allprocedures } = visit;
      for (let i = 0; i < allprocedures.length; i++) {
        let procedure = allprocedures[i];

        procedure["invoiceNumber"] = "invoive number";
      }
    } */

    //view claim submission response
    if (visit) {
      this.setState({ claimSubmissionstatus: visit.claimsubmissionstatus })
      if (visit.claimsubmissionstatus !== "1") {
        if (visit.outcome === "complete") {
          this.setState({ errorsRow: [], allproceduresRows: [] });
          let {
            items,
            adjucationoutcome,
            allprocedures,
            claimtype,
            supportinginformation,
            diagnosis,
          } = visit;
          console.log(items);

          if (items && items.length > 0) {
            const claimSubmissionItemsRows = items.map((element, index) => {
              const adjudicationRows = element.adjudications?.map(
                (element, index) => {
                  console.log(element.reason);
                  return (
                    <TableRow key={index}>
                      <TableCell align="center" style={{ fontSize: "small" }}>
                        {element.category}
                      </TableCell>
                      <TableCell align="center" style={{ fontSize: "small" }}>
                        {element.amount}
                      </TableCell>
                    </TableRow>
                  );
                }
              );
              return (
                <TableRow key={index}>
                  <TableCell align="center" style={{ padding: "0" }}>
                    <TableContainer component={Paper}>
                      <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead style={{ backgroundColor: "#fafafa" }}>
                          <TableRow style={{ textAlign: "center" }}>
                            <TableCell align="center">Code</TableCell>
                            <TableCell align="center">Description</TableCell>
                            <TableCell align="center">Price</TableCell>
                            <TableCell align="center">Quantity</TableCell>
                            <TableCell align="center">Tax</TableCell>
                            <TableCell align="center">
                              Supporting Information
                            </TableCell>
                            <TableCell align="center">Diagnosis</TableCell>
                            {claimtype == "oral" ? (
                              <TableCell align="center">Body Site</TableCell>
                            ) : null}
                          </TableRow>
                        </TableHead>
                        <TableBody>{this.state.allproceduresRows}</TableBody>
                      </Table>
                    </TableContainer>
                  </TableCell>
                  <TableCell align="center" style={{ fontSize: "small" }}>
                    {element.outcome}
                  </TableCell>
                  {element.reason ? (
                    <>
                      <TableCell align="center" style={{ fontSize: "small" }}>
                        {element.reason}
                      </TableCell>
                      <TableCell align="center" style={{ fontSize: "small" }}>
                        {element.denailCode}
                      </TableCell>
                    </>
                  ) : null}

                  <TableCell align="center" style={{ padding: "0" }}>
                    <TableContainer component={Paper}>
                      <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead style={{ backgroundColor: "#fafafa" }}>
                          <TableRow style={{ textAlign: "center" }}>
                            <TableCell
                              align="center"
                              style={{ fontSize: "small" }}
                            >
                              category
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontSize: "small" }}
                            >
                              amount
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>{adjudicationRows}</TableBody>
                      </Table>
                    </TableContainer>
                  </TableCell>
                </TableRow>
              );
            });
            this.setState({ claimSubmissionItemsRows, adjucationoutcome });
          }

        } else if (visit.outcome === "queued") {
          const queuedInfoRows = (
            <TableRow>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {visit.claimresponseoutcome}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                The claim Submission for the selected activities is qeued , try to
                pull the response anothertime ,and the bundle id is
                {visit.claimrequestbundleid}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {visit.claimrequestidentifier}
              </TableCell>
            </TableRow>
          );
          this.setState({ queuedInfoRows });
        }
      }
    }

  };

  ClaimSubmissionRequest = async (e, id, claimSubmissionID) => {
    let {nphiesID} = this.state
    e.preventDefault();
    this.setState({
      authRequestSent: true,
      authResponse: false,
    });
    let CheckAuthorizationResponse = await axios.post(
      KayanURL + "api/KSA/RCM/uploadClaims/ClaimSubmissionRequest",
      {
        claimSubmissionID: claimSubmissionID,
        claimId: id,
        testing: nphiesID === "10000300178702" ? true : false,
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );
    if (CheckAuthorizationResponse) {
      this.setState({ RequestSent: false, response: true });
      let { data } = CheckAuthorizationResponse;
      console.log("here", CheckAuthorizationResponse);
      if (data) {
        let { success } = data;
        if (success) {
          this.setState({
            success: true,
            allvisits: data.allVisits,
          });
        }
      }
    }
  };
  handleTextChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  handleCloseClaimInfo = () => {
    this.setState({ viewClaimSubmissionInfoModal: false });
  };
  handleSubmitBatch = async (e) => {
    let { nphiesID } = this.state
    console.log(this.state.claims);
    e.preventDefault();
    this.setState({
      BatchRequestSent: true,
      BatchResponse: false,
      batchSubmissionError: null,
    });

    let BatchSubmissionResponse = await axios.post(
      // KayanURL
      "http://141.147.130.248:4000/" + "api/KSA/RCM/request",
      {
        apiToken: "token",
        requestType: "4",
        payerID: "INS-FHIR",
        payerName: "Psedue Payer",
        TPA: "",
        providerID: "10000300178702",
        providerName: "faraby",
        batchPeriodFrom: this.state.startdate,
        batchPeriodTo: this.state.enddate,
        testing: nphiesID === "10000300178702" ? true : false,

        // providerID: "10000300113683",
        // providerName: "Al-Faraby Medical Center (Dhahran)",
        // payerID: "7001571327",
        // payerName: "Bupa Arabia for Cooperative Insurance Co (21860)",
        // TPA: "",
        // batchPeriodFrom: this.state.startdate,
        // batchPeriodTo: this.state.enddate,

        claims: this.state.claims,
      }
    );
    console.log("Batch submission response", BatchSubmissionResponse);

    if (BatchSubmissionResponse) {
      this.setState({
        BatchRequestSent: false,
        BatchResponse: true,
        claims: [],
        checkboxFlag: false,
      });
      let { data } = BatchSubmissionResponse;
      if (data) {
        let { success, error } = data;
        if (success) {
          let { BatchBundleID, responses } = data;

          this.setState({
            BatchResponseStatus: "success",
            BatchBundleID,
            BatchResponses: responses,
          });

          //update the status of each claim in database
          //update the claim with the response

          if (responses && responses.length > 0) {
            for (let i = 0; i < responses.length; i++) {
              const claimResponse = responses[i];

              let {
                providerClaimID,
                BundleID,
                outcome,
                errors,
                requestIdentifier,
                ResponseBuisnessIdentifier,
              } = claimResponse;

              let updateClaimStatusResult = await axios.post(
                "http://localhost:4000/" + "api/KSA/RCM/Claims/updateClaim",
                {
                  apiToken: Cookies.get("RCM_KSA_Employee_Token"),
                  providerClaimID,
                  BundleID,
                  outcome,
                  requestIdentifier,
                  ResponseBuisnessIdentifier,
                  claimsubmissionstatus: outcome == "error" ? "2" : outcome == "queued" ? "4" : "",
                  BatchBundleID,
                  errors,
                }
              );
              console.log("updateClaimStatusResult", updateClaimStatusResult);
              this.handleSearchRequest()
            }
          }
        } else {
          console.log("batch submission error");
          console.log(error);

          this.setState({ batchSubmissionError: error });
        }
      }
    }
  };
  handleCansulation = async (e) => {
    let { claimsForCancel, nphiesID } = this.state
      = e.preventDefault();
    this.setState({
      cancelRequestSent: true,
      cancelResponse: false,
    });
    let requestIdentifierError = []
    for (let i = 0; i < claimsForCancel.length; i++) {
      let CancelResponse = await axios.post(
        // KayanURL
        "http://141.147.130.248:4000/" + "api/KSA/RCM/request",
        {
          apiToken: "token",
          requestType: "6",
          payerID: claimsForCancel[i].payer_id,
          providerID: claimsForCancel[i].provider_id,
          providerName: claimsForCancel[i].provider_name,
          payerName: claimsForCancel[i].payer_name,
          requestIdentifier: claimsForCancel[i].claim_request_identifier,
          code: "cancel",
          testing: nphiesID === "10000300178702" ? true : false,
        }
      );
      // console.log("cancel Response", cancelResponse);

      if (CancelResponse) {
        this.setState({
          cancelRequestSent: false,
          cancelResponse: true,
          checkboxFlag: false,
        });
        let { data } = CancelResponse;
        if (data) {
          console.log(data)
          let { success, error } = data;
          if (success) {
            console.log(success)
          } else {
            requestIdentifierError.push(claimsForCancel[i].claim_request_identifier)
          }
        }
      }
    }
    this.setState({
      claimsForCancel: []
    })
    console.log("request identifier :", requestIdentifierError)

  };
  handleCheckBoxChange = (
    e,
    selectedVisit,
    index /*  providerClaimID, claimSubmissionID, index */
  ) => {
    let { allvisits, claims, claimsForCancel } = this.state;

    if (e.target.name == "allClaimSubmission") {
      if (e.target.checked) {
        claims = [];
        if (allvisits && allvisits.length > 0) {
          for (let i = 0; i < allvisits.length; i++) {
            //build the structure of the claim

            let visit = allvisits[i];

            let claim = {
              /*  payerID: visit["payer_id"],
              payerName: visit["payer_name"],
              providerID: visit["provider_id"],
              providerName: visit["provider_name"], */
              patient: {
                ID: visit["patient_identifier"],
                firstName: visit["patient_first_name"],
                lastName: visit["patient_last_name"],
                gender: visit["patient_gender"],
                birthDate: visit["patient_dob"],
                nationality: visit["patient_nationality"],
                identifierType: visit["identifier_type"],
              },
              visitNumber: visit["visitnumber"],
              doctor: {
                firstName: visit["doctor_first_name"],
                lastName: visit["doctor_last_name"],
                practiceCode: visit["doctor_practice_code"],
                license: visit["doctor_license"],
              },
              claimType: visit["claim_type"],
              claimSubType: visit["claim_sub_type"],

              supportingInformation: visit.supportinginformation,

              diagnosis: visit.diagnosis,
              codingSystem: "internal",
              procedures: visit.procedures,
              coverage: {
                period: {
                  start: visit.coverage_start_date,
                  end: visit.coverage_end_date,
                },
                memberid: visit.coverage_member_id,
                network: visit.network,
                "subscriber-relationship": visit.subscriber_relationship,
                "coverage-type": visit.coverage_type,
                class: [
                  /*   {
                    type: "group",
                    name: "group",
                    value: "SABIC",
                  }, */
                  {
                    type: "plan",
                    name: "plan",
                    value: visit.policy_number,
                  },
                  {
                    type: "class",
                    name: "class",
                    value: visit.class,
                  },
                ],
                paymentDetails: [
                  {
                    copaypct: visit.copaypct,
                  },
                  {
                    maxcopay: visit.maxcopay,
                  },
                ],
              },
              providerClaimID: visit.claimid,
              EligibilityOffline: visit.eligibilityoffline,
              eligibilityOfflineDate: visit.eligibilityofflinedate,
              EligibilityResponseIdentifier:
                visit.eligibilityresponseidentifier,
              AuthorizationOffline: visit.authorizationoffline,
              preAuthOfflineDate: visit.preauthofflinedate,
              preAuthRef: visit.preauthref,
              preAuthResponseIdentifier: visit.preauthresponseidentifier,
            };
            claims.push(claim);
            claimsForCancel.push({
              claim_request_identifier: visit.claim_request_identifier,
              payer_id: visit.payer_id,
              payer_name: visit.payer_name,
              provider_id: visit.provider_id,
              provider_name: visit.provider_name
            })
          }

          if (claims && claims.length > 0) {
            this.setState({
              claims,
              checkboxFlag: true,
              batchSubmissionFlag: true,
            });
          }
        } else {
          this.setState({
            claims: [],
            claimsForCancel: [],
            checkboxFlag: false,
            batchSubmissionFlag: false,
          });
        }
      } else {
        this.setState({
          claims: [],
          checkboxFlag: false,
          batchSubmissionFlag: false,
        });
      }
    } else {
      //this.setState({ checkboxFlag: false });
      if (e.target.checked) {
        selectedVisit.checked = true;
        let visit = selectedVisit;

        let claim = {
          /*  payerID: visit["payer_id"],
              payerName: visit["payer_name"],
              providerID: visit["provider_id"],
              providerName: visit["provider_name"], */
          patient: {
            ID: visit["patient_identifier"],
            firstName: visit["patient_first_name"],
            lastName: visit["patient_last_name"],
            gender: visit["patient_gender"],
            birthDate: visit["patient_dob"],
            nationality: visit["patient_nationality"],
            identifierType: visit["identifier_type"],
          },
          visitNumber: visit["visitnumber"],
          doctor: {
            firstName: visit["doctor_first_name"],
            lastName: visit["doctor_last_name"],
            practiceCode: visit["doctor_practice_code"],
            license: visit["doctor_license"],
          },
          claimType: visit["claim_type"],
          claimSubType: visit["claim_sub_type"],

          supportingInformation: visit.supportinginformation,

          diagnosis: visit.diagnosis,
          codingSystem: "internal",
          procedures: visit.procedures,
          coverage: {
            period: {
              start: visit.coverage_start_date,
              end: visit.coverage_end_date,
            },
            memberid: visit.coverage_member_id,
            network: visit.network,
            "subscriber-relationship": visit.subscriber_relationship,
            "coverage-type": visit.coverage_type,
            class: [
              {
                type: "plan",
                name: "plan",
                value: visit.policy_number,
              },
              {
                type: "class",
                name: "class",
                value: visit.class,
              },
            ],
            paymentDetails: [
              {
                copaypct: visit.copaypct,
              },
              {
                maxcopay: visit.maxcopay,
              },
            ],
          },
          providerClaimID: visit.claimid,
          EligibilityOffline: visit.eligibilityoffline,
          eligibilityOfflineDate: visit.eligibilityofflinedate,
          EligibilityResponseIdentifier: visit.eligibilityresponseidentifier,
          AuthorizationOffline: visit.authorizationoffline,
          preAuthOfflineDate: visit.preauthofflinedate,
          preAuthRef: visit.preauthref,
          preAuthResponseIdentifier: visit.preauthresponseidentifier,
        }
        claims.push(claim);
        claimsForCancel.push({
          claim_request_identifier: visit.claim_request_identifier,
          payer_id: visit.payer_id,
          payer_name: visit.payer_name,
          provider_id: visit.provider_id,
          provider_name: visit.provider_name
        })
        if (claims && claims.length >= 2) {
          this.setState({ batchSubmissionFlag: true });
        }
        this.setState({ claims, claimsForCancel });
      } else {
        selectedVisit.checked = false;
        claims.forEach((item, i) => {
          if (/* item.index  */ i == index) {
            let i = claims.indexOf(item);
            claims.splice(i, 1);
          }
        });
        claimsForCancel.forEach((item, i) => {
          if (i == index) {
            let i = claimsForCancel.indexOf(item);
            claimsForCancel.splice(i, 1);
          }
        });
        if (claims.length == 0) {
          this.setState({ batchSubmissionFlag: false });
        }
        this.setState({ checkboxFlag: false });

        this.setState({ claims });
      }
    }
  };
  HandleDateChange = (e) => {
    let date = moment(e.value.$d).format("YYYY-MM-DD");
    this.setState({
      searchInfo: { ...this.state.searchInfo, [e.name]: date },
      [e.name]: date,
      searchDefaultValue: null,
    });
  };
  HandleInputSearchRequestTextChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    // console.log(e.view.document);
    /*  if (name === "payer_id") {
      this.setState({ defaultpayerIdValue: value });
    } */
    this.setState({
      searchInfo: { ...this.state.searchInfo, [name]: value },
      [name]: value,
      //searchDefaultValue: null,
    });
  };
  handleSearchRequest = async () => {
    let { searchInfo } = this.state;

    console.log("searchInfo", searchInfo);
    // searchInfo["claimsubmissionstatus"] = this.state.claimSubmissionstatus;

    let result = await axios.put(
      /* KayanURL */ "http://localhost:4000/api/KSA/RCM/Claims/getAllClaimSubmission",
      {
        searchInfo /* {
          enddate: "2023-10-30",
          payer_id: "INS-FHIR",
          startdate: "2023-10-01",
        } */,
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );
    if (result) {
      let { data } = result;
      console.log(data);
      if (data) {
        //this.setState({ requestsFound: true });
        this.setState({ searchClaimResponse: true });
        if (data.success) {
          this.setState({ success: true, allvisits: data.claims });
        } else {
          this.setState({
            success: false,
            error: data.error,
            allvisits: [],
            searchInfo: {},
          });
        }
      }
    }
  };
  render() {
    let { allvisits } = this.state;
    console.log(this.state.claimsForCancel, "cancel")
    console.log(this.state.claims, "claims")
    let visitRows, claimOption;
    //console.log(this.state.claims);
    if (allvisits && allvisits.length > 0) {
      visitRows = allvisits.map((element, index) => {
        let claimsubmissionstatus, color;
        if (element.claimsubmissionstatus === "1") {
          claimsubmissionstatus = "Pending";
          color = "grey";
          claimOption = "ClaimSubmission";
        } else if (element.claimsubmissionstatus === "2") {
          claimsubmissionstatus = "Faild";
          color = "red";
          claimOption = "ClaimSubmission";
        } else if (element.claimsubmissionstatus === "3") {
          claimsubmissionstatus = "Complete";
          color = "green";
          claimOption = "";
        } else if (element.claimsubmissionstatus === "4") {
          claimsubmissionstatus = "Queued";
          color = "yellow";
        }
        // console.log("this.state.checkboxFlag", this.state.checkboxFlag);
        return (
          <TableRow key={index}>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {this.state.checkboxFlag ? (
                <Checkbox
                  checked={this.state.checkboxFlag}
                  onChange={(e) =>
                    this.handleCheckBoxChange(
                      e,
                      element,
                      index
                      /* element["claimid"],
                    element.id,
                    index */
                    )
                  }
                />
              ) : (
                <Checkbox
                  checked={element.checked ? true : false}
                  onChange={(e) =>
                    this.handleCheckBoxChange(
                      e,
                      element,
                      index
                      /* element["claimid"],
                    element.id,
                    index */
                    )
                  }
                />
              )}
            </TableCell>

            <TableCell align="center" style={{ fontSize: "small" }}>
              <a
                style={{
                  cursor: "pointer",
                  width: "10px ",
                  height: "10px",
                  backgroundColor: color,
                  padding: "4px 9px",
                  borderRadius: "15%",
                  color: "white",
                }}
                onClick={() =>
                  this.getAllClaimInformation(/* element["claimid"] */ element)
                }
              >
                {element["claimid"]}
              </a>
              {/* {element.claimsubmissionstatus === '1' || element.claimsubmissionstatus === '2' ? (
                <IconButton
                  onClick={() => {
                    this.setState({
                      claimInfoModal: true,claimInfo:element
                    });
                  }}
                >
                  <EditIcon style={{ color: "grey" }} icon="fluent:delete-12-regular" />
                </IconButton>
              ) : null} */}

            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element["patient_identifier"]}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {`${element["patient_first_name"]} ${element["patient_last_name"]}`}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element["patient_file_number"]}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element["payer_id"]}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element["claim_date"]}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {claimsubmissionstatus}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              <MoreOptions
                handleSubmit={(e) =>
                  this.ClaimSubmissionRequest(e, element["claimid"], element.id)
                }
                optionFor={claimOption}
                claimSubmissionstatus={claimsubmissionstatus}
                handleDelete={() =>
                  this.handleDeleteClaimSubmission(element.id)
                }
              />
            </TableCell>
          </TableRow>
        );
      });
    }

    /******************new code *********************/
    let { selectedVisit } = this.state;

    let allDiagnosisRows = [];
    let allproceduresRows = [], errorsRow = [];
    let relatedDiagnosis;
    let supportingInformationTable = [];
    let total = 0;
    let itemError = [], diagnosisError = []
    if (this.state.selectedVisit) {
      // let {errorsRow}=this.state;
      if (selectedVisit.outcome === "error") {
        let { errors } = selectedVisit;
        console.log(errors);
        if (errors && errors.length > 0) {
          errorsRow = errors.map((element, index) => {
            if (element.code === "IB-00030" || element.code === "IB-00238") {
              itemError.push({
                indexItem: element.extension.split(".")[5].split("[")[1].split("]")[0],
                extension: element.display
              })
              // console.log('itemError:',itemError)

            } else if (element.code === "IB-00242") {
              diagnosisError.push({
                indexItem: element.extension.split(".")[5].split("[")[1].split("]")[0],
                extension: element.display
              })
            }
            return (
              <TableRow key={index}>
                <TableCell align="center" style={{ fontSize: "small" }}>
                  {element.code}
                </TableCell>
                <TableCell align="center" style={{ fontSize: "small" }}>
                  {element.display}
                </TableCell>
                <TableCell align="center" style={{ fontSize: "small" }}>
                  {element.extension}
                </TableCell>
              </TableRow>
            );
          });
        }
      }
      let {
        procedures,
        diagnosis,
        supportinginformation,
        /*   authorizationstatus, */
        claimsubmissionstatus,
      } = selectedVisit;
      if (diagnosis && diagnosis.length > 0) {
        if (diagnosisError && diagnosisError.length > 0) {
          diagnosis.forEach((element) => {
            diagnosisError.forEach((ele) => {
              if (diagnosis.indexOf(element) == ele.indexItem) {
                element["error"] = ele.extension
              }
            });
          });
        }
        allDiagnosisRows = diagnosis.map((element, index) => {
          console.log(element)
          return (
            <TableRow key={index}>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {index + 1}{" "}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.type}{" "}
              </TableCell>

              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.code}{" "}
              </TableCell>
              {element.error ? (
                <TableCell align="center" style={{ fontSize: "small" }}>
                  {element.error}{" "}
                </TableCell>
              ) : null}

            </TableRow>
          );
        });
        //console.log(" allDiagnosisRows", allDiagnosisRows);
      }

      if (supportinginformation && supportinginformation.length > 0) {
        supportingInformationTable = supportinginformation.map(
          (info, index) => {
            let keys = Object.keys(info);

            if (keys[0] != "attachment") {
              if (keys[0] == "chief-complaint") {
                return (
                  <TableRow key={index}>
                    <TableCell align="center" style={{ fontSize: "small" }}>
                      {index + 1}{" "}
                    </TableCell>
                    <TableCell align="center" style={{ fontSize: "small" }}>
                      {keys[0]}
                    </TableCell>

                    <TableCell align="center" style={{ fontSize: "small" }}>
                      {`Text: ` +
                        info[[keys[0]]].text +
                        `\n ICD: ` +
                        info[[keys[0]]].ICD
                        ? info[[keys[0]]].ICD
                        : ""}
                    </TableCell>
                  </TableRow>
                );
              } else {
                return (
                  <TableRow key={index}>
                    <TableCell align="center" style={{ fontSize: "small" }}>
                      {index + 1}{" "}
                    </TableCell>
                    <TableCell align="center" style={{ fontSize: "small" }}>
                      {keys[0]}
                    </TableCell>

                    <TableCell align="center" style={{ fontSize: "small" }}>
                      {info[[keys[0]]]}
                    </TableCell>
                  </TableRow>
                );
              }
            }
          }
        );
      }

      //console.log(diagnosis);
      if (procedures && procedures.length > 0) {
        console.log(procedures)
        if (itemError && itemError.length > 0) {
          procedures.forEach((element) => {
            itemError.forEach((ele) => {
              if (procedures.indexOf(element) == ele.indexItem) {
                element["error"] = ele.extension
              }
            });
          });
        }
        allproceduresRows = procedures.map((element, index) => {
          let { Net, diagnosisSequence, informationSequence } = element;

          //  console.log(element)
          relatedDiagnosis = [];

          if (diagnosisSequence && diagnosisSequence.length > 0) {
            diagnosisSequence.forEach((seq) => {
              relatedDiagnosis.push(diagnosis[seq - 1].code);
            });
          }

          total += Net;
          return (
            <TableRow key={index}>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.type}{" "}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.code}{" "}
              </TableCell>

              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.description}
              </TableCell>

              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.date}
              </TableCell>

              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.quantity}
              </TableCell>

              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.price}
              </TableCell>

              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.discount}%
              </TableCell>

              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.tax}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.patientshare_total}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.invoice}
              </TableCell>

              {informationSequence && informationSequence.length > 0 ? (
                <TableCell align="center" style={{ fontSize: "small" }}>
                  {informationSequence.toString()}
                </TableCell>
              ) : null}
              {relatedDiagnosis && relatedDiagnosis.length > 0 ? (
                <TableCell align="center" style={{ fontSize: "small" }}>
                  {relatedDiagnosis.toString()}
                </TableCell>
              ) : (
                <TableCell align="center" style={{ fontSize: "small" }}>

                </TableCell>
              )}

              {claimsubmissionstatus && claimsubmissionstatus == "3" ? (
                <TableCell align="center" style={{ fontSize: "small" }}>
                  <TableRow align="center">
                    <TableCell align="center" style={{ fontSize: "small" }}>
                      Outcome
                    </TableCell>
                    <TableCell align="center" style={{ fontSize: "small" }}>
                      {element.claimSubmissionOutcome}
                    </TableCell>
                  </TableRow>

                  {element.claimSubmissionOutcome == "rejected" ||
                    element.claimSubmissionOutcome == "partial" ? (
                    <TableRow>
                      <TableCell align="center" style={{ fontSize: "small" }}>
                        Rejection Reason
                      </TableCell>
                      <TableCell align="center" style={{ fontSize: "small" }}>
                        {/*   {element.reason} */}
                      </TableCell>
                    </TableRow>
                  ) : null}

                  {element.claimSubmissionOutcome == "rejected" ||
                    element.claimSubmissionOutcome == "partial" ? (
                    <TableRow>
                      <TableCell align="center" style={{ fontSize: "small" }}>
                        Denail Code
                      </TableCell>
                      <TableCell align="center" style={{ fontSize: "small" }}>
                        {/*  {element.denailCode} */}
                      </TableCell>
                    </TableRow>
                  ) : null}
                  {element.claimSubmissionAdjudications &&
                    element.claimSubmissionAdjudications.length > 0 ? (
                    <TableRow>
                      <TableCell
                        colSpan={2}
                        align="center"
                        style={{ fontSize: "small" }}
                      >
                        Adjudications Outcome
                      </TableCell>
                    </TableRow>
                  ) : null}

                  {element.claimSubmissionAdjudications &&
                    element.claimSubmissionAdjudications.length > 0
                    ? element.claimSubmissionAdjudications.map((adj, i) => {
                      return (
                        <>
                          <TableRow align="center" key={i}>
                            <TableCell
                              align="center"
                              style={{ fontSize: "small" }}
                            >
                              {adj.category}
                            </TableCell>{" "}
                            <TableCell
                              align="center"
                              style={{ fontSize: "small" }}
                            >
                              {adj.amount}
                            </TableCell>
                          </TableRow>
                        </>
                      );
                    })
                    : null}
                </TableCell>
              ) : null}
              {element.error ? (
                <TableCell align="center" style={{ fontSize: "small" }}>
                  {element.error}
                </TableCell>
              ) : null}
            </TableRow>
          );
        });
      }
    }
    return (
      <div>
        <div
          style={{
            textAlign: "center",
            margin: "auto",
            boxShadow: "1px solid grey",
            padding: "15px",
            boxShadow:
              "0px 2px 4px -1px rgba(0,0,0,0.3),0px 4px 5px 0px rgba(0,0,0,0.15),0px 1px 10px 0px rgba(0,0,0,0.11)",
            borderRadius: "10px",
            marginTop: "50px",
            width: "100%",
          }}
        >
          <Accordion
            defaultActiveKey="0"
            style={{
              margin: "auto",
              paddingBottom: "0",
              width: "80%",
            }}
          >
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                <span style={{ color: "grey" }}>Search Claim </span>
              </Accordion.Header>
              <Accordion.Body>
                <Row>
                  <Col>
                    <FormControl fullWidth sx={{ mb: 3 }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          sx={{
                            "& .MuiInputBase-input": {
                              height: "8px",
                            },
                            ".css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root":
                            {
                              fontSize: "small",
                            },
                          }}
                          name="startdate"
                          label="Claims Period Start Date"
                          onChange={(date) =>
                            this.HandleDateChange({
                              name: "startdate",
                              value: date,
                            })
                          }
                        />
                      </LocalizationProvider>
                    </FormControl>
                    <div>
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor: "rgb(97 110 120",
                          width: "100%",
                          padding: "7.5px",
                        }}
                        onClick={(e) => this.handleSearchRequest(e)}
                      >
                        search
                      </Button>
                    </div>
                  </Col>
                  <Col>
                    <FormControl fullWidth sx={{ mb: 3 }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          sx={{
                            "& .MuiInputBase-input": {
                              height: "8px",
                            },
                            ".css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root":
                            {
                              fontSize: "small",
                            },
                          }}
                          name="enddate"
                          label="Claims Period End Date"
                          onChange={(date) =>
                            this.HandleDateChange({
                              name: "enddate",
                              value: date,
                            })
                          }
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Col>
                  <Col>
                    <FormControl sx={{ mb: 3 }} style={{ width: "100%" }}>
                      <InputLabel id="insurance" style={{ fontSize: "small" }}>
                        Insurance Company
                      </InputLabel>
                      <Select
                        required
                        labelId="insurance"
                        name="payer_id"
                        label="Insurance Company"
                        value={this.state.payer_id}
                        onChange={this.HandleInputSearchRequestTextChange}
                        style={{ height: "45px" }}
                      >
                        <MenuItem
                          value="INS-FHIR"
                          style={{ fontSize: "small" }}
                        >
                          Pseudo Payer
                        </MenuItem>
                        <MenuItem
                          value="7001571327"
                          style={{ fontSize: "small" }}
                        >
                          Puba
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Col>
                  <Col>
                    <FormControl sx={{ mb: 3 }} style={{ width: "100%" }}>
                      <InputLabel id="insurance" style={{ fontSize: "small" }}>
                        Claimsubmission Status
                      </InputLabel>
                      <Select
                        required
                        labelId="Claimsubmission Status"
                        name="claimsubmissionstatus"
                        label="Claimsubmission Status"
                        value={this.state.claimsubmissionstatus}
                        onChange={this.HandleInputSearchRequestTextChange}
                        style={{ height: "45px" }}
                      >
                        <MenuItem
                          value="1"
                          style={{ fontSize: "small" }}
                        >
                          Pending
                        </MenuItem>
                        <MenuItem
                          value="2"
                          style={{ fontSize: "small" }}
                        >
                          Faild
                        </MenuItem>
                        <MenuItem
                          value="3"
                          style={{ fontSize: "small" }}
                        >
                          Complete
                        </MenuItem>
                        <MenuItem
                          value="4"
                          style={{ fontSize: "small" }}
                        >
                          Queued
                        </MenuItem>
                      </Select>
                    </FormControl>
                    {/*{AllClaims && AllClaims.length > 0 ? (
                      <>
                        <CSVLink
                          filename="reportClaims.csv"
                          data={claims}
                        headers={claimHeader}
                        >
                          <FileDownloadIcon />
                        </CSVLink>
                      </>
                   ) : null}*/}
                  </Col>
                </Row>
                <hr />
                <Row>
                  <div style={{ textAlign: "left" }}>
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: "rgb(97 110 120",
                        border: "1px ridge gray",
                        width: "31%",
                        boxShadow: "none",
                        height: "40px",
                        color: "white",
                        fontSize: "small",
                        marginTop: "20px",
                      }}
                      onClick={() => this.setState({ uploadModal: true })}
                    >
                      Upload File
                    </Button>
                  </div>
                </Row>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>

          {this.state.batchSubmissionFlag ? (
            <div style={{ width: "50%", textAlign: "center", margin: "auto" }}>
              <Button
                variant="primary"
                type="submit"
                onClick={(e) => this.handleSubmitBatch(e)}
                style={{
                  width: "45%",
                  marginTop: "32px",
                  padding: "7px",
                  backgroundColor: "rgb(97 110 120",
                  border: "1px solid rgb(97 110 120",
                  color: "white",
                }}
              >
                Batch Submission
              </Button>
              <Button
                variant="primary"
                type="submit"
                onClick={(e) => this.handleCansulation(e)}
                style={{
                  width: "45%",
                  marginTop: "32px",
                  marginLeft: "10px",
                  padding: "7px",
                  backgroundColor: "rgb(97 110 120",
                  border: "1px solid rgb(97 110 120",
                  color: "white",
                }}
              >
                Cansulation
              </Button>
            </div>
          ) : null}

          {this.state.allvisits &&
            this.state.allvisits.length > 0 &&
            this.state.searchClaimResponse ? (
            <>
              <TableContainer
                component={Paper}
                style={{ margin: "20px auto 20px" }}
              >
                <Table aria-label="simple table">
                  <TableHead style={{ backgroundColor: "#fafafa" }}>
                    <TableRow style={{ textAlign: "center" }}>
                      <TableCell align="center" style={{ fontSize: "small" }}>
                        <Checkbox
                          checked={this.state.checkboxFlag}
                          onChange={(e) => this.handleCheckBoxChange(e)}
                          name="allClaimSubmission"
                        />
                      </TableCell>
                      <TableCell align="center">Claim ID</TableCell>
                      <TableCell align="center">Iqama</TableCell>
                      <TableCell align="center">Patient Name</TableCell>
                      <TableCell align="center">Medical File Number</TableCell>
                      <TableCell align="center">Payer ID</TableCell>
                      <TableCell align="center">Claim Date</TableCell>
                      <TableCell align="center">
                        Claim Submission Status
                      </TableCell>
                      <TableCell align="center">Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>{visitRows}</TableBody>
                </Table>
              </TableContainer>
            </>
          ) : this.state.searchClaimResponse &&
            this.state.allvisits &&
            this.state.allvisits.length == 0 ? (
            <>
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                style={{ textAlign: "center", marginTop: "30px" }}
              >
                There is now row found!
              </Typography>
            </>
          ) : null}


          {this.state.viewClaimSubmissionInfoModal ? (
            <>
              <Modal
                open={this.state.viewClaimSubmissionInfoModal}
                onClose={this.handleCloseClaimInfo}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box
                  sx={style}
                  style={{ width: "90%", height: "500px", overflowY: "scroll" }}
                >
                  <div
                    style={{
                      width: "100%",
                      backgroundColor: "rgb(191 186 186)",
                      margin: "auto",
                      marginTop: "10px",
                      padding: "15px",
                      paddingBottom: "10px",
                      borderRadius: "24px",
                    }}
                  >
                    <Row>
                      <Col style={{ padding: "20px" }}>
                        <Typography
                          id="modal-modal-description"
                          sx={{ mt: 2 }}
                          style={{ textTransform: "capitalize" }}
                        >
                          Patient Identifier: {selectedVisit.patient_identifier}
                        </Typography>
                        <Typography
                          id="modal-modal-description"
                          sx={{ mt: 2 }}
                          style={{ textTransform: "capitalize" }}
                        >
                          Name:
                          {`${selectedVisit.patient_first_name} ${selectedVisit.patient_last_name}`}{" "}
                        </Typography>
                        <Typography
                          id="modal-modal-description"
                          sx={{ mt: 2 }}
                          style={{ textTransform: "capitalize" }}
                        >
                          Medical File Number:{" "}
                          {selectedVisit.patient_file_number}
                        </Typography>
                      </Col>
                      <Col style={{ padding: "20px" }}>
                        <Typography
                          id="modal-modal-description"
                          sx={{ mt: 2 }}
                          style={{ textTransform: "capitalize" }}
                        >
                          Gender: {selectedVisit.patient_gender}
                        </Typography>
                        <Typography
                          id="modal-modal-description"
                          sx={{ mt: 2 }}
                          style={{ textTransform: "capitalize" }}
                        >
                          Nationality: {selectedVisit.patient_nationality}
                        </Typography>
                        <Typography
                          id="modal-modal-description"
                          sx={{ mt: 2 }}
                          style={{ textTransform: "capitalize" }}
                        >
                          Age: {selectedVisit.age}
                        </Typography>
                      </Col>
                      {this.state.checkEligibilityInfo || 1 ? (
                        <Col style={{ padding: "20px" }}>
                          <Typography
                            id="modal-modal-description"
                            sx={{ mt: 2 }}
                            style={{ textTransform: "capitalize" }}
                          >
                            Insurance Company: {selectedVisit.payer_id}
                          </Typography>

                          <Typography
                            id="modal-modal-description"
                            sx={{ mt: 2 }}
                          >
                            Eligibility Type:{" "}
                            {selectedVisit.eligibilityoffline
                              ? "Offline"
                              : "Online"}
                          </Typography>

                          {selectedVisit.eligibilityoffline ? (
                            <Typography
                              id="modal-modal-description"
                              sx={{ mt: 2 }}
                            >
                              Eligibility Date:{" "}
                              {selectedVisit.eligibilityofflinedate}
                            </Typography>
                          ) : null}
                          <Typography
                            id="modal-modal-description"
                            sx={{ mt: 2 }}
                          >
                            Eligibility Number:{" "}
                            {selectedVisit.eligibilityresponseidentifier}
                          </Typography>
                          {selectedVisit.preauthref ? (
                            <>
                              <Typography
                                id="modal-modal-description"
                                sx={{ mt: 2 }}
                              >
                                Approval Number: {selectedVisit.preauthref}
                              </Typography>
                              <Typography
                                id="modal-modal-description"
                                sx={{ mt: 2 }}
                              >
                                Approval Reference:{" "}
                                {selectedVisit.preauthresponseidentifier}
                              </Typography>
                            </>
                          ) : null}
                        </Col>
                      ) : null}
                      {this.state.coverageInfo || 1 ? (
                        <>
                          <Col style={{ padding: "20px" }}>
                            <Typography
                              id="modal-modal-description"
                              sx={{ mt: 2 }}
                              style={{ textTransform: "capitalize" }}
                            >
                              {/**
                               * 
                                                                  * copaypct
                                    : 
                                    "20"
                                    coverage_end_date
                                    : 
                                    "45142"
                                    coverage_member_id
                                    : 
                                    "undefined"
                                    coverage_start_date
                                    : 
                                    "45128"
                                    coverage_type
                                    : 
                                    "EHCPOL"
                               */}
                              Member ID: {selectedVisit.coverage_member_id}
                            </Typography>
                            <Typography
                              id="modal-modal-description"
                              sx={{ mt: 2 }}
                              style={{ textTransform: "capitalize" }}
                            >
                              Network: {selectedVisit.network}
                            </Typography>

                            <Typography
                              id="modal-modal-description"
                              sx={{ mt: 2 }}
                              style={{ textTransform: "capitalize" }}
                            >
                              Policy Number: {selectedVisit.policy_number}
                            </Typography>
                            <Typography
                              id="modal-modal-description"
                              sx={{ mt: 2 }}
                              style={{ textTransform: "capitalize" }}
                            >
                              Period: From {selectedVisit.coverage_start_date}{" "}
                              To {selectedVisit.coverage_end_date}
                            </Typography>
                            <Typography
                              id="modal-modal-description"
                              sx={{ mt: 2 }}
                              style={{ textTransform: "capitalize" }}
                            >
                              Payment Details:
                            </Typography>
                            <Typography
                              id="modal-modal-description"
                              sx={{ mt: 2 }}
                              style={{ textTransform: "capitalize" }}
                            >
                              Copaypct:{selectedVisit.copaypct}
                            </Typography>
                            <Typography
                              id="modal-modal-description"
                              sx={{ mt: 2 }}
                              style={{ textTransform: "capitalize" }}
                            >
                              Maxcopay:{selectedVisit.maxcopay}
                            </Typography>
                          </Col>
                        </>
                      ) : null}
                    </Row>
                  </div>

                  <hr />
                  <Row>
                    <Col xs={6}>
                      {allDiagnosisRows && allDiagnosisRows.length > 0 ? (
                        <div
                          style={{
                            margin: "auto",
                            width: "50%",
                          }}
                        >
                          <TableContainer
                            component={Paper}
                            style={{ marginTop: "10px" }}
                          >
                            <Table aria-label="simple table">
                              <TableHead style={{ backgroundColor: "#fafafa" }}>
                                <TableRow>
                                  <TableCell align="center" colSpan={4}>
                                    Diagnosis
                                  </TableCell>
                                </TableRow>
                                <TableRow style={{ textAlign: "center" }}>
                                  <TableCell align="center">ID</TableCell>
                                  <TableCell align="center">Type</TableCell>
                                  <TableCell align="center">Code</TableCell>
                                  <TableCell align="center">error</TableCell>
                                </TableRow>
                              </TableHead>

                              <TableBody>{allDiagnosisRows}</TableBody>
                            </Table>
                          </TableContainer>
                        </div>
                      ) : null}
                    </Col>
                    <Col xs={6}>
                      {supportingInformationTable &&
                        supportingInformationTable.length > 0 ? (
                        <>
                          <div style={{ margin: "auto" }}>
                            <TableContainer
                              component={Paper}
                              style={{ marginTop: "10px", width: "50%" }}
                            >
                              <Table aria-label="simple table">
                                <TableHead
                                  style={{ backgroundColor: "#fafafa" }}
                                >
                                  <TableRow>
                                    <TableCell align="center" colSpan={3}>
                                      Supporting Information
                                    </TableCell>
                                  </TableRow>
                                  <TableRow style={{ textAlign: "center" }}>
                                    <TableCell align="center">ID</TableCell>
                                    <TableCell align="center">
                                      Information
                                    </TableCell>
                                    <TableCell align="center">Value</TableCell>
                                  </TableRow>
                                </TableHead>

                                <TableBody>
                                  {supportingInformationTable}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </div>
                        </>
                      ) : null}
                    </Col>
                  </Row>
                  <hr />
                  {allproceduresRows && allproceduresRows.length > 0 ? (
                    <>
                      <div style={{ width: "100%", margin: "auto" }}>
                        <TableContainer
                          component={Paper}
                          style={{
                            margin: "auto",
                            marginTop: "30px",
                            width: "100%",
                          }}
                        >
                          <Table aria-label="simple table">
                            <TableHead style={{ backgroundColor: "#fafafa" }}>
                              <TableRow style={{ textAlign: "center" }}>
                                <TableCell align="center">Type</TableCell>
                                <TableCell align="center">Code</TableCell>
                                <TableCell align="center">
                                  Description
                                </TableCell>
                                <TableCell align="center">Date</TableCell>
                                <TableCell align="center">Price</TableCell>
                                <TableCell align="center">Quantity</TableCell>
                                <TableCell align="center">Discount</TableCell>
                                <TableCell align="center">Tax</TableCell>
                                <TableCell align="center">
                                  Patient Share
                                </TableCell>
                                <TableCell align="center">
                                  Invoice Number
                                </TableCell>
                                <TableCell align="center">
                                  Supporting Information
                                </TableCell>
                                <TableCell align="center">Diagnosis</TableCell>
                                {/*  <TableCell align="center">
                                  Claim Submission Status
                                </TableCell>
 */}
                                {/*  {this.state.dentalServiceType ? (
                                  <>
                                    <TableCell align="center">
                                      Tooth Number
                                    </TableCell>
                                    <TableCell align="center">
                                      Tooth Description
                                    </TableCell>
                                  </>
                                ) : null} */}
                                <TableCell align="center">Error</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>{allproceduresRows}</TableBody>
                          </Table>
                        </TableContainer>
                      </div>
                    </>
                  ) : null}
                  {this.state.items && this.state.items.length > 0 ? (
                    <>
                      <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="h2"
                        style={{ textAlign: "center" }}
                      >
                        Adjudication OutCome :{this.state.adjucationoutcome}
                      </Typography>
                      <TableContainer
                        component={Paper}
                        style={{
                          margin: "auto",
                          marginTop: "30px",
                          width: "100%",
                        }}
                      >
                        <Table aria-label="simple table">
                          <TableHead style={{ backgroundColor: "#fafafa" }}>
                            <TableRow style={{ textAlign: "center" }}>
                              <TableCell align="center">Items</TableCell>
                              <TableCell align="center">Outcome</TableCell>
                              {this.state.adjucationoutcome == "rejected" ||
                                this.state.adjucationoutcome == "partial" ? (
                                <>
                                  <TableCell align="center">Reason</TableCell>
                                  <TableCell align="center">
                                    Denail Code
                                  </TableCell>
                                </>
                              ) : null}
                              <TableCell align="center">Adjudication</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {this.state.claimSubmissionItemsRows}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </>
                  ) : null}
                  {errorsRow && errorsRow.length > 0 && this.state.claimSubmissionstatus === "2" ? (
                    <>
                      <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="h2"
                        style={{ textAlign: "center", marginTop: "10px" }}
                      >
                        Errors
                      </Typography>
                      <div
                        style={{
                          width: "100%",
                          margin: "auto",
                          paddingBottom: "20px",
                        }}
                      >
                        <TableContainer
                          component={Paper}
                          style={{
                            margin: "auto",
                            marginTop: "30px",
                            width: "100%",
                          }}
                        >
                          <Table aria-label="simple table">
                            <TableHead style={{ backgroundColor: "#fafafa" }}>
                              <TableRow style={{ textAlign: "center" }}>
                                <TableCell align="center">Error Code</TableCell>
                                <TableCell align="center">
                                  Error Display
                                </TableCell>
                                <TableCell align="center">
                                  Error Extention
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>{errorsRow}</TableBody>
                          </Table>
                        </TableContainer>
                      </div>
                    </>
                  ) : null}
                  {this.state.queuedFlag ? (
                    <div
                      style={{
                        width: "85%",
                        margin: "auto",
                        paddingBottom: "20px",
                      }}
                    >
                      <TableContainer
                        component={Paper}
                        style={{
                          margin: "auto",
                          marginTop: "30px",
                          width: "100%",
                        }}
                      >
                        <Table aria-label="simple table">
                          <TableHead style={{ backgroundColor: "#fafafa" }}>
                            <TableRow style={{ textAlign: "center" }}>
                              <TableCell align="center">Outcome</TableCell>
                              <TableCell align="center">Bundle Id</TableCell>
                              <TableCell align="center">
                                Request Identifier
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>{this.state.queuedInfoRows}</TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  ) : null}
                </Box>
              </Modal>
            </>
          ) : null}
          {this.state.uploadModal ? (
            <>
              <Modal
                open={this.state.uploadModal}
                onClose={this.closeUploadModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ overflowY: "scroll" }}
              >
                <Box
                  sx={styleModal}
                  style={{
                    width: "30%",
                    height: "200px",
                    border: "1px solid white",
                    textAlign: "center",
                  }}
                >
                  <input
                    style={{
                      display: "block",
                      margin: "auto",
                      marginRight: "5px",
                    }}
                    type="file"
                    onChange={this.onFileChange}
                  />
                  {this.state.errMsg ? (
                    <>
                      <div style={{ textAlign: "center" }}>
                        <span
                          style={{
                            color: "red",
                            fontSize: "10px",
                          }}
                        >
                          {this.state.errMsg}
                        </span>
                      </div>
                    </>
                  ) : null}

                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: "rgb(97 110 120",
                      border: "1px ridge gray",
                      width: "40%",
                      boxShadow: "none",
                      height: "35px",
                      color: "white",
                      fontSize: "small",
                      marginTop: "20px",
                    }}
                    onClick={this.handleFileUpload}
                  >
                    Upload File
                  </Button>
                </Box>
              </Modal>
            </>
          ) : null}
          {/* {this.state.claimInfoModal ? (
            <>
              <Modal
                open={this.state.claimInfoModal}
                onClose={this.closeClaimInfoModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ overflowY: "scroll" }}
              >
                <Box
                  sx={styleModal}
                  style={{
                    width: "90%",
                    height: "600px",
                    border: "1px solid white",
                    textAlign: "center",
                  }}
                >
                  <EditClaimInfo claimInfo={this.state.claimInfo}/>
                </Box>
              </Modal>
            </>
          ) : null} */}
          {this.state.BatchRequestSent && !this.state.BatchResponse ? (
            <CircularProgress />
          ) : !this.state.BatchRequestSent &&
            this.state.BatchResponse &&
            this.state.batchSubmissionError ? (
            <Snackbar
              open={
                !this.state.BatchRequestSent &&
                this.state.BatchResponse &&
                this.state.batchSubmissionError
              }
              autoHideDuration={6000}
              onClose={this.handleCloseErrorMessage}
            >
              <Alert
                onClose={this.handleCloseErrorMessage}
                severity="warning"
                sx={{ width: "100%" }}
              >
                {this.state.batchSubmissionError}
              </Alert>
            </Snackbar>
          ) : null}
        </div>
      </div >
    );
  }
}

export default claimsUpload;
